var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveSine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M615.657 271.562C610.032 290.438 557.938 456 463.438 456C381.688 456 344.907 351.156 312.438 258.656C281.75 171.156 246.969 72 176.563 72C109.219 72 58.813 180.75 39.657 245C38.407 249.219 33.938 251.844 29.719 250.375C25.469 249.125 23.063 244.656 24.344 240.438C29.969 221.562 82.063 56 176.563 56C258.313 56 295.094 160.844 327.563 253.344C358.25 340.844 393.032 440 463.438 440C530.782 440 581.188 331.25 600.344 267C601.594 262.781 606.157 260.219 610.282 261.625C614.532 262.875 616.938 267.344 615.657 271.562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSine);
export default __webpack_public_path__ + "static/media/wave-sine.29c47e48740b9426642ffff17fd979d7.svg";
export { ForwardRef as ReactComponent };